import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { SalesTokenModuleEnum, SchoolState } from "./types";
import SchoolService from "@/services/school.service";
import { AxiosError, AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

const service: SchoolService = new SchoolService();

export const actions: ActionTree<SchoolState, RootState> = {
  getSchoolRequestDetail({ state }, callback: ActionCallback) {
    service
      .getSchoolRequestDetail(callback?.params)
      .then((response: AxiosResponse) => {
        if (response) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  addSchoolRequest(_, callback: ActionCallback) {
    service
      .addSchoolRequest(callback?.params)
      .then((response: AxiosResponse) => {
        if (response) {
          toast.success("Success.");
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  schoolRequestRegister({ state }, callback: ActionCallback) {
    const promise = new Promise<AxiosResponse>((resolve, reject) => {
      const { schoolRequestRegister, schoolRequestSalesRegister } = service

      switch (state.salesToken?.module) {
        case SalesTokenModuleEnum.JOBFAIR: {
          reject()
          break;
        }
        case SalesTokenModuleEnum.SCHOOL: {
          schoolRequestSalesRegister(callback?.params).then(resolve).catch(reject)
          break;
        }
        default: {
          schoolRequestRegister(callback?.params).then(resolve).catch(reject)
          break;

        }
      }
    })

    promise.then((response) => {
      if (response) {
        toast.success("Success.");
        if (callback && callback.success) callback.success(response);
      }
    }).catch((error: AxiosError) => {
      if (callback && callback.fail) callback.fail(error);
    }).finally(() => {
      if (callback && callback.finally) callback.finally();
    });
  },
  schoolRequestRegisterFree({ state }, callback: ActionCallback) {
    const promise = new Promise<AxiosResponse>((resolve, reject) => {
      const { schoolRequestRegisterFree } = service
      schoolRequestRegisterFree(callback?.params).then(resolve).catch(reject)
    })

    promise.then((response) => {
      if (response) {
        toast.success("Success.");
        if (callback && callback.success) callback.success(response);
      }
    }).catch((error: AxiosError) => {
      if (callback && callback.fail) callback.fail(error);
    }).finally(() => {
      if (callback && callback.finally) callback.finally();
    });
  },
  schoolRequestValidateToken({ state }, callback: ServiceCallParams) {
    service
      .schoolRequestValidateToken(callback?.params, callback?.config)
      .then((response) => {
        if (response) {
          state.salesToken = response.data.data
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  schoolRequestSendOTP({ state }, callback: ServiceCallParams) {
    service
      .schoolRequestSendOTP(callback?.params)
      .then((response) => {
        if (callback && callback.success) callback.success(response);
        return response
      })
      .catch((error) => {
        if (callback && callback.fail) callback.fail(error);
        return error
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  schoolRequestValidateOTP({ state }, callback: ServiceCallParams) {
    service
      .schoolRequestValidateOTP(callback?.params)
      .then((response) => {
        if (callback && callback.success) callback.success(response);
        return response
      })
      .catch((error) => {
        if (callback && callback.fail) callback.fail(error);
        return error
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
